<template>
    <div class="w-full flex flex-column gap-2 text-sm xl:text-base lg:text-base relative">
        <span v-if="recipient.confirm!==undefined" class="flex align-items-center">
            <span class="text-600">Подтвержден:</span>
            <Tag :severity="(recipient.confirm) ? 'success' : 'warn'" class="text-sm ml-1"
                :value="(recipient.confirm) ? 'Да' : 'Нет'" />
        </span>
        <span v-if="recipient.date_created" class="flex">
            <span class="text-600">Создан:</span>
            <span class="ml-2">{{ formatDate(recipient.date_created) }}</span>
        </span>
        <span v-if="recipient.currency_code" class="flex">
            <span class="text-600">Валюта:</span>
            <span class="ml-2">{{ toUpperCase(recipient.currency_code) }}</span>
        </span>
        <span v-if="recipient.bank_code" class="flex gap-2 flex-row">
            <span class="flex text-600">Банк:</span>
            <span class="flex">{{ getBankTitle(recipient.bank_code) }}</span>
            <img :src="getBankImage(recipient.bank_code)" class="flex" style="width:1rem">
        </span>
        <div v-if="recipient.fields" class="flex flex-column gap-2">
            <span v-if="recipient.fields.fullname" class="flex">
                <span class="text-600">Имя:</span>
                <span class="ml-2">{{ recipient.fields.fullname }}</span>
                <span @click="copy(recipient.fields.fullname)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
            <span v-if="recipient.fields.phone_number" class="flex">
                <span class="text-600">Номер телефона:</span>
                <span class="ml-2">{{ recipient.fields.phone_number }}</span>
                <span @click="copy(recipient.fields.phone_number)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
            <span v-if="recipient.fields.account_number" class="flex">
                <span class="text-600">Номер аккаунта:</span>
                <span class="ml-2">{{ recipient.fields.account_number }}</span>
                <span @click="copy(recipient.fields.account_number)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
            <span v-if="recipient.fields.card_number" class="flex">
                <span class="text-600">Номер карты:</span>
                <span class="ml-2">{{ recipient.fields.card_number }}</span>
                <span @click="copy(recipient.fields.card_number)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
            <span v-if="recipient.fields.wallet_address" class="flex">
                <span class="text-600">Адрес кошелька:</span>
                <span class="ml-2">{{ recipient.fields.wallet_address }}</span>
                <span @click="copy(recipient.fields.wallet_address)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
            <span v-if="recipient.fields.wallet_network" class="flex">
                <span class="text-600">Сеть кошелька:</span>
                <span class="ml-2">{{ recipient.fields.wallet_network }}</span>
            </span>
            <span v-if="recipient.fields.telegram" class="flex">
                <span class="text-600">Telegram:</span>
                <a :href="'https://t.me/'+recipient.fields.telegram" target="_blank" class="cursor-pointer text-primary ml-2">
                    {{ recipient.fields.telegram }}
                </a>
                <span @click="copy(recipient.fields.telegram)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
            <span v-if="recipient.fields.bank_name" class="flex">
                <span class="text-600">Банк:</span>
                <span class="ml-2">{{ recipient.fields.bank_name }}</span>
            </span>
            <span v-if="recipient.fields.address" class="flex">
                <span class="text-600">Адрес:</span>
                <span class="ml-2">{{ recipient.fields.address }}</span>
            </span>
            <span v-if="recipient.fields.city" class="flex">
                <span class="text-600">Город:</span>
                <span class="ml-2">{{ recipient.fields.city }}</span>
            </span>
            <span v-if="recipient.fields.country" class="flex">
                <span class="text-600">Страна:</span>
                <span class="ml-2">{{ recipient.fields.country }}</span>
            </span>
            <span v-if="recipient.fields.swift_code" class="flex">
                <span class="text-600">SWIFT:</span>
                <span class="ml-2">{{ recipient.fields.swift_code }}</span>
                <span @click="copy(recipient.fields.swift_code)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
            <span v-if="recipient.fields.iban_number" class="flex">
                <span class="text-600">IBAN:</span>
                <span class="ml-2">{{ recipient.fields.iban_number }}</span>
                <span @click="copy(recipient.fields.iban_number)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
            <span v-if="recipient.fields.upi_id" class="flex">
                <span class="text-600">UPI ID:</span>
                <span class="ml-2">{{ recipient.fields.upi_id }}</span>
                <span @click="copy(recipient.fields.upi_id)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
            </span>
        </div>
        <span v-if="recipient.confirm!=undefined" class="flex gap-2 flex-row align-items-center">
            <span class="flex text-600">Отметка получателем:</span>
            <Tag :severity="(recipient.confirm) ? 'success' : 'warn'" class="text-sm ml-1"
                :value="(recipient.confirm) ? 'Да' : 'Нет'" />
            <span v-if="recipient.confirm_date" class="ml-2"> 
                {{ formatDate(recipient.confirm_date) }}
            </span>
        </span>
        <span v-if="recipient.recipient_id" class="flex">
            <span class="text-600">ID получателя:</span>
            <span class="ml-2">{{ getShortTd(recipient.recipient_id) }}</span>
            <span @click="copy(recipient.recipient_id)" class="flex pi pi-copy ml-2 text-500 text-xs font-medium cursor-pointer"></span>
            <span @click="goTorecipient(recipient.recipient_id)" class="flex pi pi-external-link cursor-pointer text-xs font-medium text-primary ml-2"></span>
        </span>
        <div class="absolute flex right-0 bottom-0 mr-0 mb-0">
            <span class="w-full">
                <AvatarGroup v-if="recipient && recipient.bank_code">
                    <Avatar :image="getBankImage(recipient.bank_code)" size="normal" shape="circle" class="surface-0"/>
                </AvatarGroup>
            </span>
        </div>
    </div>
</template>

<script>
import Helper from '@/assets/js/Helper.js'
import { BankList, PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    name: 'Recipient',
    props: {
        recipient: {
            type: Object,
            required: true
        }
    },
    data: function() {
        return {
            bank_list: [],
            payment_systems: [],
        }
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        }
    },
    methods: {
        formatDate(value) {
            return this.helper.format_date(value)
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : null
        },
        toUpperCase(value) {
            if (!value) return ''
            if(typeof value != 'string') return ''
            return value.toUpperCase()
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        goTorecipient(id){
            if(!id) return
            window.open(`/admin/recipients/?id=${id}`, '_blank')
        },
        getShortTd(value){
            return this.helper.get_short_id(value)
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
        async LoadPaymentSystems(){
            this.payment_systems = await PaymentSystemList.GetList(this.$store).then(r=>r)
            if(!this.payment_systems || !this.payment_systems.length) this.payment_systems = []
        },
    },
    beforeCreate() {
        this.helper = new Helper()
    },
    mounted() {
        this.LoadBankList()
        this.LoadPaymentSystems()
    },
}
</script>